import React, { useReducer } from 'react';
import ResultadoReducer from './resultadoReducer';
import ResultadoContext from './resultadoContext';
import clienteAxios from '../../config/axios';

import { 
    OBTENER_RESULTADOS,
    ERROR_OBTENER_RESULTADOS,
    PAGINA_ACTUAL,
    OBTENER_ID_RESULTADO_SELECCIONADO
 } from '../../types';

const ResultadoState = props => {
    const inicialState = {
        resultados: [],
        paginaActual: 1,
        idSeleccionado: 0
    }

    const [ state, dispatch ] = useReducer(ResultadoReducer, inicialState);

    const obtenerResultados = async datos => {
        try {
            const respuesta = await clienteAxios.post('/resultados', datos);
            const r = respuesta.data;

            if(r){
                dispatch({
                    type: OBTENER_RESULTADOS,
                    payload: r
                })
            } 
        } catch (error) {
            dispatch({
                type: ERROR_OBTENER_RESULTADOS
            })
        }
    }

    const establecerPaginaActual = pagina => {
        dispatch({
            type: PAGINA_ACTUAL,
            payload: pagina
        })
    }

    const seleccionarResultado = id => {
        dispatch({
            type: OBTENER_ID_RESULTADO_SELECCIONADO,
            payload: id
        })
    }

    return ( 
        <ResultadoContext.Provider
            value={{
                resultados: state.resultados,
                paginaActual: state.paginaActual,
                idSeleccionado: state.idSeleccionado,
                obtenerResultados,
                establecerPaginaActual,
                seleccionarResultado
            }}
        >
            {props.children}
        </ResultadoContext.Provider>
     )
}

 export default ResultadoState;